import { isRejectedWithValue, Middleware, MiddlewareAPI } from "@reduxjs/toolkit";
import { store } from "../";
import { actionCreators } from "../store/notifications/NotificationStore";
import { TranslationKey } from "../translations/TranslationKey";
import { ApiResponse } from "./CustomFetch";

const addNotifications = (errors: TranslationKey[] | string[] | undefined, data?: any) => {
  const notificationErrors = errors !== undefined && errors.length !== undefined ? errors : ["common.errorMessage"];
  actionCreators.addNotifications(notificationErrors, data)(store.dispatch, store.getState);
};

export const globalApiErrorHandler: Middleware = (api: MiddlewareAPI) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    let errors: TranslationKey[] | string[] | undefined = action.payload?.data?.errors;
    addNotifications(errors);
  }

  return next(action);
};

export const globalErrorHandler = (response: any) => {
  if (!response) {
    return null;
  }
  if (response.status === 200) {
    return response;
  }

  const originalResponse = response.clone();
  const contentType: string = response.headers.get("content-type") || "";
  const processResponse = typeof response.json === "function" && contentType.includes("json");
  if (processResponse) {
    response
      .json()
      .then((response: ApiResponse<any>) => {
        const { success, errors, data } = response;
        if (!success) {
          addNotifications(errors, data);
        }
      })
      .catch();
  }

  return originalResponse;
};
